export const slide = [
  "/img/certification/cert_1.png",
  "/img/certification/cert_2.png",
  "/img/certification/cert_3.png",
  "/img/certification/cert_4.png",
  "/img/certification/cert_5.png",
  "/img/certification/cert_6.png",
  "/img/certification/cert_7.png",
  "/img/certification/cert_8.png",
  "/img/certification/cert_9.png",
  "/img/certification/cert_10.png",
  "/img/certification/cert_11.png",
  "/img/certification/cert_12.png",
  "/img/certification/cert_13.png",
  "/img/certification/cert_14.png",
  "/img/certification/cert_15.png",
  "/img/certification/cert_16.png",
  "/img/certification/cert_17.png",
];
